import { Navigate, Route, Routes } from 'react-router-dom'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { PrivacyNotice } from './components/PrivacyNotice'
import { RevealObserver } from './components/RevealObserver'
import { ScrollToTop } from './components/ScrollToTop'
import { RouteSEO } from './components/SEO'
import { Contact } from './pages/Contact'
import { GivingBack } from './pages/GivingBack'
import { Home } from './pages/Home'
import { JoinTeam } from './pages/JoinTeam'
import { NotFound } from './pages/NotFound'
import { OurSpace } from './pages/OurSpace'
import { PrivacyPolicy } from './pages/PrivacyPolicy'
import { Products } from './pages/Products'
import { Services } from './pages/Services'
import { Team } from './pages/Team'

export default function App() {
  return (
    <div className="site-wrap">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <ScrollToTop />
      <RouteSEO />
      <RevealObserver />
      <Header />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/team" element={<Team />} />
          <Route path="/our-space" element={<OurSpace />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/giving-back" element={<GivingBack />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/join-our-team" element={<JoinTeam />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <PrivacyNotice />
    </div>
  )
}
